webpackJsonp([1],{

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Insilico_logo.b0be91c.svg";

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(314)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(222),
  /* template */
  __webpack_require__(341),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(311)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(232),
  /* template */
  __webpack_require__(338),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 205:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_js__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__main__ = __webpack_require__(54);







__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);

var apiRoot = '/api';
if (false) {
	apiRoot = 'http://localhost:8000/api';
}

function isEmptyObject(o) {
	return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(o).some(function (x) {
		return o[x] === '' || o[x] === null;
	});
}

var store = new __WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */].Store({
	state: {
		token: null,
		user: JSON.parse(localStorage.getItem('user')),
		isLoggedIn: !!localStorage.getItem('token'),
		experiment: {},
		experiments_list: [],
		molecules: [],
		profile: {},
		profile_updated: false,
		is_profile_filled: true,
		errors: {}
	},
	getters: {

		isLoggedIn: function isLoggedIn(state) {
			return state.isLoggedIn;
		},
		getUser: function getUser(state) {
			return state.user;
		},
		getErrors: function getErrors(state) {
			return function () {
				return state.errors;
			};
		},
		getProfileUpdated: function getProfileUpdated(state) {
			return function () {
				return state.profile_updated;
			};
		},
		getProfileFilled: function getProfileFilled(state) {
			return state.is_profile_filled;
		}

	},
	mutations: {
		'LOGIN_SUCCESS': function LOGIN_SUCCESS(state, params) {
			var response = params[0];
			var is_registred = params[1];
			state.isLoggedIn = true;
			state.token = response.body.token;
			state.user = response.body.user;

			localStorage.setItem('token', response.body.token);
			localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.body.user));

			__WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');

			if (is_registred) __WEBPACK_IMPORTED_MODULE_5__main__["router"].push('/profile');else state.is_profile_filled = true;
		},

		'LOGOUT_SUCCESS': function LOGOUT_SUCCESS(state, response) {
			localStorage.removeItem('token');
			localStorage.removeItem('user');

			state.token = null;
			state.user = {};
			state.isLoggedIn = false;
		},
		'GET_PROFILE': function GET_PROFILE(state, response) {
			var obj_profile = response.body[0];
			state.profile = obj_profile;

			if (!isEmptyObject(obj_profile)) state.is_profile_filled = true;else state.is_profile_filled = false;
		},
		'UPDATE_PROFILE': function UPDATE_PROFILE(state, response) {
			state.profile_updated = !state.profile_updated;
			state.is_profile_filled = true;
		},
		'ADD_EXPERIMENT': function ADD_EXPERIMENT(state, response) {

			state.experiment = response.body;
		},
		'GET_EXPERIMENT': function GET_EXPERIMENT(state, response) {
			var experiment = response.body;

			var mols = [];
			experiment.reactions.forEach(function (obj) {
				var molecule = obj.molecule;
				molecule.guess = obj.reaction;
				molecule.data = obj.data;
				mols.push(molecule);
			});
			state.molecules = mols;
			state.experiment = experiment;
		},
		'DELETE_EXPERIMENT': function DELETE_EXPERIMENT(state, experiment_id) {

			var i = state.experiments_list.map(function (item) {
				return item.id;
			}).indexOf(experiment_id);
			state.experiments_list.splice(i, 1);
		},
		'GET_EXPERIMENT_LIST': function GET_EXPERIMENT_LIST(state, response) {

			state.experiments_list = response.body;
		},
		'GET_MOLECULES': function GET_MOLECULES(state, response) {
			state.molecules = response.body;
		},
		'RATE_MOLECULE': function RATE_MOLECULE(state, response) {},
		'API_FAIL': function API_FAIL(state, error) {
			console.error(error);
			state.errors = error;
		}
	},
	actions: {
		login: function login(store, payload) {
			return __WEBPACK_IMPORTED_MODULE_4__api_js__["a" /* default */].post(apiRoot + '/rest-auth/login/', { 'username': payload.login, 'password': payload.password }).then(function (response) {
				return store.commit('LOGIN_SUCCESS', [response, 0]);
			}).catch(function (error) {
				return store.commit('API_FAIL', error);
			});
		},
		logout: function logout(store) {
			return __WEBPACK_IMPORTED_MODULE_4__api_js__["a" /* default */].post(apiRoot + '/rest-auth/logout/').then(function (response) {
				return store.commit('LOGOUT_SUCCESS', response);
			}).catch(function (error) {
				return store.commit('API_FAIL', error);
			});
		},
		register: function register(store, payload) {
			return __WEBPACK_IMPORTED_MODULE_4__api_js__["a" /* default */].post(apiRoot + '/rest-auth/registration/', { 'username': payload.username,
				'email': payload.email,
				'password1': payload.password1,
				'password2': payload.password2 }).then(function (response) {
				return store.commit('LOGIN_SUCCESS', [response, 1]);
			}).catch(function (error) {
				return store.commit('API_FAIL', error);
			});
		},
		getProfile: function getProfile(store) {
			var user = JSON.parse(localStorage.getItem('user'));
			return __WEBPACK_IMPORTED_MODULE_4__api_js__["a" /* default */].get(apiRoot + '/profile/', { 'user': user.id }).then(function (response) {
				return store.commit('GET_PROFILE', response);
			}).catch(function (error) {
				return store.commit('API_FAIL', error);
			});
		},
		updateProfile: function updateProfile(store, payload) {
			return __WEBPACK_IMPORTED_MODULE_4__api_js__["a" /* default */].patch(apiRoot + '/profile/' + payload.profile.id + '/', payload.profile).then(function (response) {
				return store.commit('UPDATE_PROFILE', response);
			}).catch(function (error) {
				return store.commit('API_FAIL', error);
			});
		},
		addExperiment: function addExperiment(store, payload) {

			console.log('Adding an Experiment: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload));

			return __WEBPACK_IMPORTED_MODULE_4__api_js__["a" /* default */].post(apiRoot + '/experiments/', { 'user': payload.user, 'exp_type': payload.exp_type }).then(function (response) {
				return store.commit('ADD_EXPERIMENT', response);
			}).catch(function (error) {
				return store.commit('API_FAIL', error);
			});
		},
		rateMolecule: function rateMolecule(context, payload) {
			var store = context;
			var state = context.state;
			console.log(state.experiment.id);
			return __WEBPACK_IMPORTED_MODULE_4__api_js__["a" /* default */].post(apiRoot + '/molecule-reactions/', { 'experiment': state.experiment.id,
				'molecule': payload.molecule,
				'reaction': payload.reaction,
				'data': payload.data,
				'rawdata': payload.rawdata }).then(function (response) {
				return store.commit('RATE_MOLECULE', response);
			}).catch(function (error) {
				return store.commit('API_FAIL', error);
			});
		},
		getExperiment: function getExperiment(store, experiment_id) {
			return __WEBPACK_IMPORTED_MODULE_4__api_js__["a" /* default */].get(apiRoot + '/experiments/' + experiment_id + '/').then(function (response) {
				return store.commit('GET_EXPERIMENT', response);
			}).catch(function (error) {
				return store.commit('API_FAIL', error);
			});
		},
		deleteExperiment: function deleteExperiment(store, experiment_id) {
			return __WEBPACK_IMPORTED_MODULE_4__api_js__["a" /* default */].delete(apiRoot + '/experiments/' + experiment_id + '/').then(function (response) {
				return store.commit('DELETE_EXPERIMENT', experiment_id);
			}).catch(function (error) {
				return store.commit('API_FAIL', error);
			});
		},
		getExperimentList: function getExperimentList(store) {
			return __WEBPACK_IMPORTED_MODULE_4__api_js__["a" /* default */].get(apiRoot + '/experiments/').then(function (response) {
				return store.commit('GET_EXPERIMENT_LIST', response);
			}).catch(function (error) {
				return store.commit('API_FAIL', error);
			});
		},
		getMolecules: function getMolecules(store) {
			return __WEBPACK_IMPORTED_MODULE_4__api_js__["a" /* default */].get(apiRoot + '/molecules/').then(function (response) {
				return store.commit('GET_MOLECULES', response);
			}).catch(function (error) {
				return store.commit('API_FAIL', error);
			});
		}
	}
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 206:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(312)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(220),
  /* template */
  __webpack_require__(339),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(306)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(223),
  /* template */
  __webpack_require__(333),
  /* scopeId */
  "data-v-0ee2348b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(310)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(224),
  /* template */
  __webpack_require__(337),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(308)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(226),
  /* template */
  __webpack_require__(335),
  /* scopeId */
  "data-v-3d0475c7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(315)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(227),
  /* template */
  __webpack_require__(342),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(305)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(229),
  /* template */
  __webpack_require__(332),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(307)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(230),
  /* template */
  __webpack_require__(334),
  /* scopeId */
  "data-v-2ef44328",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(309)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(231),
  /* template */
  __webpack_require__(336),
  /* scopeId */
  "data-v-3fb1630e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 220:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {},
  data: function data() {
    return {
      contacts: [],
      error: "No Errors!"
    };
  },

  methods: {
    performLogout: function performLogout() {
      this.$store.dispatch('logout');
      this.$router.push('/');
    },
    redirectProfile: function redirectProfile() {
      this.$router.push('/profile');
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$store.watch(this.$store.getters.getErrors, function (error) {

      var encode = JSON.parse(error.bodyText);
      var error_desc = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(encode).join(", ");

      _this.error = 'Error! ' + error_desc;
      _this.$refs.snackbar.open();
    });
    this.$store.watch(this.$store.getters.getProfileUpdated, function (profile_updated) {
      _this.error = 'Profile was successfully updated!';
      _this.$refs.snackbar.open();
    });
  }
});

/***/ }),

/***/ 221:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_cortex__ = __webpack_require__(53);






var timerObj;
var cortexClient;
var onMet;

var device_ready_timerObj;
var cortex_api_auth = {
  username: 'insilico',
  password: 'emotivPass',
  client_id: 'XfQ1sX8m03qTilfr68vn7FEpJyDnTl6yklJkfozp',
  client_secret: 'GZvKlQAuuuotygVA0U3DbVDjoM6vd34Nz4i13grieeblM4GHG5tEfnTAzUfDT8e4tSosvgQ2qfkvJ1zGzucpkslXIMc8wcawNC4hS7TOOTipH9lx9qHreowN9tF5nxRD',
  debit: 1 };
var data = [];

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'userform',
  props: ['experiment_type'],
  data: function data() {
    return {
      moleculeIndex: 0,
      guessedRight: 0,
      guessedWrong: 0,
      ganLiked: 0,
      humanLiked: 0,
      emotive_device: '',
      met_int: 0,
      met: {
        interest: 0,
        stress: 0,
        relaxation: 0,
        excitement: 0,
        engagement: 0,
        long_term_excitement: 0,
        focus: 0
      },
      show_emo_state: false,
      loaded: false
    };
  },
  beforeCreate: function beforeCreate() {},
  created: function created() {
    var _this = this;

    this.$store.dispatch('addExperiment', { 'exp_type': this.experiment_type, 'user': this.currentUser.pk });
    this.$store.dispatch('getMolecules').then(function () {
      if (_this.experiment_type == 2) {
        cortexClient = cortexClient || new __WEBPACK_IMPORTED_MODULE_2__lib_cortex__["a" /* default */]();
        console.log('Waiting for device');
        cortexClient.ready.then(function () {
          return cortexClient.init(cortex_api_auth);
        }).then(function () {
          return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            var hs = null;
            device_ready_timerObj = window.setInterval(function () {
              console.log('Checking device');
              hs = cortexClient.queryHeadsets();
            }, 500);
            setTimeout(function () {
              window.clearTimeout(device_ready_timerObj);
              device_ready_timerObj = null;
              resolve(hs);
            }, 2500);
          });
        }).then(function (hs) {
          if (hs.length != 0) {
            _this.loaded = true;

            _this.emotive_device = hs[0].id;


            cortexClient.createSession({
              _auth: cortexClient._auth,
              status: 'active',
              headset: hs[0].id
            }).then(function () {
              return cortexClient.subscribe({ streams: ['met'] });
            }).then(function (subs) {
              console.log('Subscribed to' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(subs));
              if (!subs[0].met) throw new Error('failed to subscribe');
              onMet = function onMet(ev) {
                console.log('MET: ' + ev.met);
                data.push(ev.met);
                _this.met.interest = ev.met[0] * 100;
                _this.met.stress = ev.met[1] * 100;
                _this.met.relaxation = ev.met[2] * 100;
                _this.met.excitement = ev.met[3] * 100;
                _this.met.engagement = ev.met[4] * 100;
                _this.met.long_term_excitement = ev.met[5] * 100;
                _this.met.focus = ev.met[6] * 100;
              };
              cortexClient.on('met', onMet);
            }).then(function () {
              return _this.startTimer();
            });
          } else {
            console.log('Could not start Experiment without headset connected');
          }
        });
      } else {
        _this.loaded = true;
        _this.startTimer();
      }
    });
  },

  computed: {
    mols: function mols() {
      return this.$store.state.molecules;
    },
    isAuth: function isAuth() {
      return this.$store.getters.isLoggedIn;
    },
    currentUser: function currentUser() {
      return this.$store.getters.getUser;
    }
  },
  watch: {
    moleculeIndex: function moleculeIndex() {
      this.stopTimer();
      if (this.moleculeIndex < this.mols.length) {
        this.startTimer();
        if (this.experiment_type == 2) {
          this.record_eeg();
        }
      } else this.$router.push({ name: 'experiment_result', params: { 'id': this.$store.state.experiment.id } });
    } },
  methods: {
    rate: function rate(mollId, molDesign, moleculeIndex, reaction) {

      if (this.experiment_type == 1) {
        if (molDesign == reaction) {
          this.guessedRight++;
          this.mols[moleculeIndex].guess = 1;
        } else {
          this.guessedWrong++;
          this.mols[moleculeIndex].guess = 0;
        }
      } else {
        if (reaction == 0) this.mols[moleculeIndex].guess = 1;
        if (reaction == 1) this.mols[moleculeIndex].guess = 0;
      }

      this.$store.dispatch('rateMolecule', { 'molecule': mollId, 'reaction': reaction });
      this.moleculeIndex++;
    },
    startTimer: function startTimer() {
      timerObj = window.setInterval(this.timerTick, 5000);
    },
    stopTimer: function stopTimer() {
      window.clearInterval(timerObj);
      timerObj = null;
    },
    timerTick: function timerTick() {
      this.moleculeIndex++;
    },
    connect_to_device: function connect_to_device() {},
    get_average_data: function get_average_data() {
      var averages = [];

      data.forEach(function (col, _i) {
        col.forEach(function (e, i) {
          return averages[i] = averages[i] === undefined ? col[i] : averages[i] + col[i];
        });
      });

      averages.forEach(function (col, i) {
        return averages[i] = averages[i] / data.length;
      });
      return averages;
    },
    record_eeg: function record_eeg() {
      var _this2 = this;

      var molecule = this.mols[this.moleculeIndex];
      console.info('Recording DATA for molecule #: ' + this.moleculeIndex);
      console.info(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(molecule));
      console.log(data);
      var avgs = this.get_average_data();

      var reaction = avgs[0].toFixed();

      console.log("Computed Reaction: " + reaction);
      this.mols[this.moleculeIndex].data = avgs;
      console.log("Human interest value on molecule: " + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.mols[this.moleculeIndex]) + "| EXC: " + this.mols[this.moleculeIndex].eeg_int);

      var guessed = function guessed(reaction) {
        return reaction === _this2.mols[_this2.moleculeIndex].design;
      };
      switch (guessed(reaction)) {
        case true:
          this.mols[this.moleculeIndex].guess = 1;
        case false:
          this.mols[this.moleculeIndex].guess = 0;
      }

      this.$store.dispatch('rateMolecule', {
        'molecule': molecule.id,
        'reaction': reaction,
        'rawdata': data,
        'data': avgs
      });
      data = [];
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.stopTimer();
    if (this.experiment_type == 2) {
      cortexClient.unsubscribe({ streams: ['met'] }).then(function () {
        return cortexClient.updateSession({ status: 'close' });
      }).then(function () {
        return cortexClient.removeListener('met', onMet);
      }).then(function () {
        return cortexClient.close();
      });
      cortexClient = null;
    }
  }
});

/***/ }),

/***/ 222:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'experiment-choice',
  props: [],
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    isProfileFilled: 'getProfileFilled'
  })),
  methods: {
    gotoExperimentLike: function gotoExperimentLike() {
      this.$router.push({ name: 'preexperiment', params: { 'experiment_type': 0 } });
    },
    gotoExperimentGan: function gotoExperimentGan() {
      this.$router.push({ name: 'preexperiment', params: { 'experiment_type': 1 } });
    },
    gotoExperimentCortex: function gotoExperimentCortex() {
      this.$router.push({ name: 'preexperiment', params: { 'experiment_type': 2 } });
    }

  }
});

/***/ }),

/***/ 223:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_cortex__ = __webpack_require__(53);









var client = null;

function rollingAverage(columns, windowSize) {
  var avgCount = 0;
  var averages = {};
  return function (row) {
    avgCount = Math.min(windowSize, avgCount + 1);
    columns.forEach(function (col, i) {
      var oldAvg = averages[col] || 0;
      averages[col] = oldAvg + (row[i] - oldAvg) / avgCount;
    });
    return averages;
  };
}

function numbers(client, windowSize, onResult) {
  return client.createSession({ status: 'open' }).then(client.subscribe({ streams: ['met'] })).then(function (_subs) {
    console.log(_subs);
    var subs = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default.a.apply(Object, [{}].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(_subs)));
    if (!subs.pow || !subs.mot || !subs.met || !subs.egg || !subs.fac || !subs.dev || !subs.sys) throw new Error('failed to subscribe');

    var bands = {
      theta: [],
      alpha: [],
      betaL: [],
      betaH: [],
      gamma: []
    };
    for (var i = 0; i < subs.pow.cols.length; i++) {
      var bandName = subs.pow.cols[i].split('/')[1];
      bands[bandName].push(i);
    }
    var bandNames = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(bands);

    var makeFriendlyCol = function makeFriendlyCol(col) {
      return col.replace(/^IMD_(.*?)([XYZ]?)$/, function (_, name, dim) {
        return name.toLowerCase() + dim;
      });
    };

    var motCols = subs.mot.cols.map(makeFriendlyCol);

    var averageMet = rollingAverage(subs.met.cols, 1);
    var averageMot = rollingAverage(motCols, windowSize);
    var averageBands = rollingAverage(bandNames, windowSize);

    var data = {};

    var _arr = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(motCols), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(subs.met.cols), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(bandNames));

    for (var _i = 0; _i < _arr.length; _i++) {
      var col = _arr[_i];
      data[col] = 0;
    }

    var onMet = function onMet(ev) {
      return maybeUpdate('met', averageMet(ev.met));
    };
    client.on('met', onMet);

    var onMot = function onMot(ev) {
      return maybeUpdate('mot', averageMot(ev.mot));
    };
    client.on('mot', onMot);

    var onCom = function onCom(ev) {
      return maybeUpdate('com', ev.com);
    };
    client.on('com', onCom);

    var current = {
      command: 'neutral',
      eyes: 'neutral',
      brows: 'neutral',
      mouth: 'neutral'
    };

    var columns2obj = function columns2obj(headers) {
      return function (cols) {
        var obj = {};
        for (var _i2 = 0; _i2 < cols.length; _i2++) {
          obj[headers[_i2]] = cols[_i2];
        }
        return obj;
      };
    };
    var fac2obj = columns2obj(subs[1].fac.cols);
    var onFac = function onFac(ev) {
      var data = fac2obj(ev.fac);

      var updated = false;
      var update = function update(k, v) {
        if (current[k] !== v) {
          updated = true;
          current[k] = v;
        }
      };

      var threshold = 0;
      update('eyes', data.eyeAct);
      if (data.uPow >= threshold) update('brows', data.uAct);
      if (data.lPow >= threshold) update('mouth', data.lAct);

      if (updated) onResult(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, current));
    };
    client.on('fac', onFac);

    var averageSensors = function averageSensors(pow) {
      return bandNames.map(function (bandName) {
        var sum = bands[bandName].map(function (i) {
          return pow[i];
        }).reduce(function (total, row) {
          return total + row;
        }, 0);
        return sum / bands[bandName].length;
      });
    };

    var onPow = function onPow(ev) {
      return maybeUpdate('bands', averageBands(averageSensors(ev.pow)));
    };
    client.on('pow', onPow);

    var hasUpdate = {};
    var maybeUpdate = function maybeUpdate(key, newdata) {
      if (hasUpdate[key]) {
        onResult(data);
        hasUpdate = {};
      }
      hasUpdate[key] = true;
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(data, newdata);
    };

    return function () {
      return client.unsubscribe({ streams: ['pow', 'mot', 'met'] }).updateSession({ status: 'close' }).then(function () {
        client.removeListener('mot', onMot);
        client.removeListener('pow', onPow);
      });
    };
  });
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Cortex',
  data: function data() {
    return {
      msg: 'Cortex API client test'
    };
  },

  methods: {
    startTest: function startTest() {
      client = client || new __WEBPACK_IMPORTED_MODULE_5__lib_cortex__["a" /* default */]({ verbose: 3 });
      var avgWindow = 10;
      var auth = {
        username: 'insilico',
        password: 'emotivPass',

        debit: 1 };
      console.log(client);
      client.ready.then(function () {
        console.log('INIT is a: ' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(client.init) + ' [ ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(client.init(auth) + ' ]'));
      }).then(function () {
        return numbers(client, avgWindow, function (averages) {
          var output = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(averages).map(function (k) {
            return k + ': ' + averages[k].toFixed(2);
          }).join(', ');

          console.log(output);
        });
      });
    },
    stopTest: function stopTest() {
      if (client && client !== null) {
        client.close();
        client = null;
      }
    }
  }
});

/***/ }),

/***/ 224:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Experiment__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Experiment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Experiment__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'experimentpage',
  props: ['experiment_type'],
  components: {
    Experiment: __WEBPACK_IMPORTED_MODULE_0__Experiment___default.a
  },
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  },

  methods: {
    testtest: function testtest() {
      this.$parent.testClick();
    }

  }
});

/***/ }),

/***/ 225:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'experimentpassed',
	props: [],

	data: function data() {
		return {};
	},
	beforeCreate: function beforeCreate() {
		this.$store.dispatch('getExperimentList');
	},


	computed: {
		experiments: function experiments() {
			var exp = this.$store.state.experiments_list;
			return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.orderBy(exp, 'started_at', 'desc');
		}
	},
	methods: {
		DeleteExperiment: function DeleteExperiment(exp_id) {
			this.$store.dispatch('deleteExperiment', exp_id);
		}
	}
});

/***/ }),

/***/ 226:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var toPersentString = function toPersentString(num) {
	try {
		return (num * 100).toFixed().toString();
	} catch (e) {
		return '-';
	}
};

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'experiment-result',
	props: [],
	data: function data() {
		return {
			msg: 'Welcome to Your Vue.js App'
		};
	},

	computed: {
		molecules: function molecules() {
			return this.$store.state.molecules;
		},
		filterGAN: function filterGAN() {
			return this.molecules.filter(function (mol) {
				return mol.design > 0;
			});
		},
		filterHuman: function filterHuman() {
			return this.molecules.filter(function (mol) {
				return mol.design < 1;
			});
		}
	},
	methods: {
		moleculeLiked: function moleculeLiked(molecule) {

			if (this.$store.state.experiment.exp_type == 0) return molecule.guess == 0;else if (this.$store.state.experiment.exp_type == 2) return false;else return molecule.design === molecule.guess;
		},
		emotive: function emotive() {
			return this.$store.state.experiment.exp_type == 2;
		},

		moleculeInterestValue: function moleculeInterestValue(mol) {
			return toPersentString(mol.data[0]);
		},
		moleculeExcitementValue: function moleculeExcitementValue(mol) {
			return toPersentString(mol.data[3]);
		},
		moleculeStressValue: function moleculeStressValue(mol) {
			return toPersentString(mol.data[1]);
		}
	},
	beforeCreate: function beforeCreate() {
		var experiment_id = this.$route.params.id;
		this.$store.dispatch('getExperiment', experiment_id);
	}
});

/***/ }),

/***/ 227:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Onboarding__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Onboarding___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Onboarding__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UserForm__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UserForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__UserForm__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'mainpage',
  props: ['testClick'],
  components: {
    Onboarding: __WEBPACK_IMPORTED_MODULE_2__Onboarding___default.a,
    UserForm: __WEBPACK_IMPORTED_MODULE_3__UserForm___default.a
  },
  data: function data() {
    return {
      current_year: new Date().getFullYear(),
      show_what_is: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    isAuth: 'isLoggedIn',
    currentUser: 'getUser'
  })),
  methods: {
    performLogout: function performLogout() {
      this.$store.dispatch('logout');
      this.$router.push('/');
    },
    redirectProfile: function redirectProfile() {
      this.$router.push('/profile');
    }
  },
  mounted: function mounted() {
    var element = document.getElementById('google_map');
    var options = {
      zoom: 14,
      center: new google.maps.LatLng(22.322527, 114.207675)
    };
    var map = new google.maps.Map(element, options);
    var position = new google.maps.LatLng(22.322527, 114.207675);
    var marker = new google.maps.Marker({
      position: position,
      map: map
    });
  }
});

/***/ }),

/***/ 228:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'onboarding',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  }
});

/***/ }),

/***/ 229:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'pre-experiment',
  props: ['experiment_type'],
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  },

  methods: {
    gotoExperiment: function gotoExperiment() {
      this.$router.push({ name: 'experiment', params: { 'experiment_type': this.experiment_type } });
    }

  }
});

/***/ }),

/***/ 230:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ExperimentChoice__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ExperimentChoice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ExperimentChoice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ExperimentPassed__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ExperimentPassed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ExperimentPassed__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'profile',
  props: [],
  components: {
    ExperimentChoice: __WEBPACK_IMPORTED_MODULE_0__ExperimentChoice___default.a,
    ExperimentPassed: __WEBPACK_IMPORTED_MODULE_1__ExperimentPassed___default.a
  },
  data: function data() {
    return {};
  },
  beforeCreate: function beforeCreate() {
    this.$store.dispatch('getProfile');
  },


  computed: {
    profile: function profile() {

      return this.$store.state.profile;
    }
  },
  methods: {
    validateProfileForm: function validateProfileForm() {
      event.preventDefault();
      this.$store.dispatch('updateProfile', { profile: this.profile });
    }
  }
});

/***/ }),

/***/ 231:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UserForm__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UserForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__UserForm__);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'testpage',
	props: [],
	components: {
		UserForm: __WEBPACK_IMPORTED_MODULE_0__UserForm___default.a
	},
	data: function data() {
		return {
			show_what_is: false

		};
	},
	created: function created() {},

	computed: {},
	methods: {
		ttt: function ttt() {
			console.log('clicked');
		}
	}
});

/***/ }),

/***/ 232:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ExperimentChoice__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ExperimentChoice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ExperimentChoice__);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'testpage',
	props: ['message'],
	components: {
		ExperimentChoice: __WEBPACK_IMPORTED_MODULE_0__ExperimentChoice___default.a
	},
	data: function data() {
		return {
			testvar: 'This is test VAR',
			login: null,
			password: null,
			username: null,
			email: null,
			password1: null,
			password2: null

		};
	},
	created: function created() {},

	computed: {
		isAuth: function isAuth() {
			return this.$store.getters.isLoggedIn;
		}
	},
	methods: {
		performLogin: function performLogin(event) {
			event.preventDefault();
			this.$store.dispatch('login', {
				login: this.login,
				password: this.password
			});
		},
		performLogout: function performLogout() {
			this.$store.dispatch('logout');
		},
		performRegister: function performRegister() {
			event.preventDefault();
			this.$store.dispatch('register', {
				username: this.username,
				email: this.email,
				password1: this.password1,
				password2: this.password2
			});
		}
	}
});

/***/ }),

/***/ 233:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(345);




__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);

if (localStorage.getItem('token')) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
} else {}

/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get(url, request) {
    return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get(url, request).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  post: function post(url, request) {
    return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.post(url, request).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  patch: function patch(url, request) {
    return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.patch(url, request).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  delete: function _delete(url, request) {
    return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.delete(url, request).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  }
});

/***/ }),

/***/ 305:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 306:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 307:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 308:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 309:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 310:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 311:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 312:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 313:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 314:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 315:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 316:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 317:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 319:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 74,
	"./af.js": 74,
	"./ar": 81,
	"./ar-dz": 75,
	"./ar-dz.js": 75,
	"./ar-kw": 76,
	"./ar-kw.js": 76,
	"./ar-ly": 77,
	"./ar-ly.js": 77,
	"./ar-ma": 78,
	"./ar-ma.js": 78,
	"./ar-sa": 79,
	"./ar-sa.js": 79,
	"./ar-tn": 80,
	"./ar-tn.js": 80,
	"./ar.js": 81,
	"./az": 82,
	"./az.js": 82,
	"./be": 83,
	"./be.js": 83,
	"./bg": 84,
	"./bg.js": 84,
	"./bm": 85,
	"./bm.js": 85,
	"./bn": 86,
	"./bn.js": 86,
	"./bo": 87,
	"./bo.js": 87,
	"./br": 88,
	"./br.js": 88,
	"./bs": 89,
	"./bs.js": 89,
	"./ca": 90,
	"./ca.js": 90,
	"./cs": 91,
	"./cs.js": 91,
	"./cv": 92,
	"./cv.js": 92,
	"./cy": 93,
	"./cy.js": 93,
	"./da": 94,
	"./da.js": 94,
	"./de": 97,
	"./de-at": 95,
	"./de-at.js": 95,
	"./de-ch": 96,
	"./de-ch.js": 96,
	"./de.js": 97,
	"./dv": 98,
	"./dv.js": 98,
	"./el": 99,
	"./el.js": 99,
	"./en-SG": 100,
	"./en-SG.js": 100,
	"./en-au": 101,
	"./en-au.js": 101,
	"./en-ca": 102,
	"./en-ca.js": 102,
	"./en-gb": 103,
	"./en-gb.js": 103,
	"./en-ie": 104,
	"./en-ie.js": 104,
	"./en-il": 105,
	"./en-il.js": 105,
	"./en-nz": 106,
	"./en-nz.js": 106,
	"./eo": 107,
	"./eo.js": 107,
	"./es": 110,
	"./es-do": 108,
	"./es-do.js": 108,
	"./es-us": 109,
	"./es-us.js": 109,
	"./es.js": 110,
	"./et": 111,
	"./et.js": 111,
	"./eu": 112,
	"./eu.js": 112,
	"./fa": 113,
	"./fa.js": 113,
	"./fi": 114,
	"./fi.js": 114,
	"./fo": 115,
	"./fo.js": 115,
	"./fr": 118,
	"./fr-ca": 116,
	"./fr-ca.js": 116,
	"./fr-ch": 117,
	"./fr-ch.js": 117,
	"./fr.js": 118,
	"./fy": 119,
	"./fy.js": 119,
	"./ga": 120,
	"./ga.js": 120,
	"./gd": 121,
	"./gd.js": 121,
	"./gl": 122,
	"./gl.js": 122,
	"./gom-latn": 123,
	"./gom-latn.js": 123,
	"./gu": 124,
	"./gu.js": 124,
	"./he": 125,
	"./he.js": 125,
	"./hi": 126,
	"./hi.js": 126,
	"./hr": 127,
	"./hr.js": 127,
	"./hu": 128,
	"./hu.js": 128,
	"./hy-am": 129,
	"./hy-am.js": 129,
	"./id": 130,
	"./id.js": 130,
	"./is": 131,
	"./is.js": 131,
	"./it": 133,
	"./it-ch": 132,
	"./it-ch.js": 132,
	"./it.js": 133,
	"./ja": 134,
	"./ja.js": 134,
	"./jv": 135,
	"./jv.js": 135,
	"./ka": 136,
	"./ka.js": 136,
	"./kk": 137,
	"./kk.js": 137,
	"./km": 138,
	"./km.js": 138,
	"./kn": 139,
	"./kn.js": 139,
	"./ko": 140,
	"./ko.js": 140,
	"./ku": 141,
	"./ku.js": 141,
	"./ky": 142,
	"./ky.js": 142,
	"./lb": 143,
	"./lb.js": 143,
	"./lo": 144,
	"./lo.js": 144,
	"./lt": 145,
	"./lt.js": 145,
	"./lv": 146,
	"./lv.js": 146,
	"./me": 147,
	"./me.js": 147,
	"./mi": 148,
	"./mi.js": 148,
	"./mk": 149,
	"./mk.js": 149,
	"./ml": 150,
	"./ml.js": 150,
	"./mn": 151,
	"./mn.js": 151,
	"./mr": 152,
	"./mr.js": 152,
	"./ms": 154,
	"./ms-my": 153,
	"./ms-my.js": 153,
	"./ms.js": 154,
	"./mt": 155,
	"./mt.js": 155,
	"./my": 156,
	"./my.js": 156,
	"./nb": 157,
	"./nb.js": 157,
	"./ne": 158,
	"./ne.js": 158,
	"./nl": 160,
	"./nl-be": 159,
	"./nl-be.js": 159,
	"./nl.js": 160,
	"./nn": 161,
	"./nn.js": 161,
	"./pa-in": 162,
	"./pa-in.js": 162,
	"./pl": 163,
	"./pl.js": 163,
	"./pt": 165,
	"./pt-br": 164,
	"./pt-br.js": 164,
	"./pt.js": 165,
	"./ro": 166,
	"./ro.js": 166,
	"./ru": 167,
	"./ru.js": 167,
	"./sd": 168,
	"./sd.js": 168,
	"./se": 169,
	"./se.js": 169,
	"./si": 170,
	"./si.js": 170,
	"./sk": 171,
	"./sk.js": 171,
	"./sl": 172,
	"./sl.js": 172,
	"./sq": 173,
	"./sq.js": 173,
	"./sr": 175,
	"./sr-cyrl": 174,
	"./sr-cyrl.js": 174,
	"./sr.js": 175,
	"./ss": 176,
	"./ss.js": 176,
	"./sv": 177,
	"./sv.js": 177,
	"./sw": 178,
	"./sw.js": 178,
	"./ta": 179,
	"./ta.js": 179,
	"./te": 180,
	"./te.js": 180,
	"./tet": 181,
	"./tet.js": 181,
	"./tg": 182,
	"./tg.js": 182,
	"./th": 183,
	"./th.js": 183,
	"./tl-ph": 184,
	"./tl-ph.js": 184,
	"./tlh": 185,
	"./tlh.js": 185,
	"./tr": 186,
	"./tr.js": 186,
	"./tzl": 187,
	"./tzl.js": 187,
	"./tzm": 189,
	"./tzm-latn": 188,
	"./tzm-latn.js": 188,
	"./tzm.js": 189,
	"./ug-cn": 190,
	"./ug-cn.js": 190,
	"./uk": 191,
	"./uk.js": 191,
	"./ur": 192,
	"./ur.js": 192,
	"./uz": 194,
	"./uz-latn": 193,
	"./uz-latn.js": 193,
	"./uz.js": 194,
	"./vi": 195,
	"./vi.js": 195,
	"./x-pseudo": 196,
	"./x-pseudo.js": 196,
	"./yo": 197,
	"./yo.js": 197,
	"./zh-cn": 198,
	"./zh-cn.js": 198,
	"./zh-hk": 199,
	"./zh-hk.js": 199,
	"./zh-tw": 200,
	"./zh-tw.js": 200
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 319;

/***/ }),

/***/ 323:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 324:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 325:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 326:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/onboarding1.35c16c9.png";

/***/ }),

/***/ 327:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/onboarding2.860bac9.png";

/***/ }),

/***/ 328:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/onboarding3.b77c065.png";

/***/ }),

/***/ 329:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(316)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(221),
  /* template */
  __webpack_require__(343),
  /* scopeId */
  "data-v-9f6cb4ec",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 330:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(317)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(225),
  /* template */
  __webpack_require__(344),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 331:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(313)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(228),
  /* template */
  __webpack_require__(340),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 332:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-layout', {
    staticClass: "preexp-layout"
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-column": "",
      "md-gutter": "",
      "md-vertical-align": "center",
      "md-align": "center"
    }
  }, [_c('h1', {
    staticClass: "exp_desc"
  }, [_vm._v("Experiment is about to start. You'll have 5 seconds on each molecule")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-accent btn-start",
    on: {
      "click": _vm.gotoExperiment
    }
  }, [_vm._v("Start Experiment")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 333:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cortex"
  }, [_c('h1', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.startTest
    }
  }, [_vm._v("Start test")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.stopTest
    }
  }, [_vm._v("Stop test")])])
},staticRenderFns: []}

/***/ }),

/***/ 334:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-layout', {
    staticClass: "main_layout",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-column": "",
      "md-gutter": ""
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "77px",
      "width": "265px",
      "margin-bottom": "50px"
    },
    attrs: {
      "src": __webpack_require__(52)
    }
  })]), _vm._v(" "), _c('md-card', {
    staticClass: "user-form-card",
    attrs: {
      "md-with-hover": ""
    }
  }, [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("Please fill in the form:")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("All fields are required")])]), _vm._v(" "), _c('md-card-content', [_c('form', {
    staticClass: "user-form",
    on: {
      "submit": _vm.validateProfileForm
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("First Name")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "placeholder": "First Name*",
      "name": "firstname",
      "required": ""
    },
    model: {
      value: (_vm.profile.first_name),
      callback: function($$v) {
        _vm.$set(_vm.profile, "first_name", $$v)
      },
      expression: "profile.first_name"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Last Name")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "placeholder": "Last Name*",
      "name": "lastname",
      "required": ""
    },
    model: {
      value: (_vm.profile.last_name),
      callback: function($$v) {
        _vm.$set(_vm.profile, "last_name", $$v)
      },
      expression: "profile.last_name"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Title")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "placeholder": "Title*",
      "name": "title",
      "required": ""
    },
    model: {
      value: (_vm.profile.title),
      callback: function($$v) {
        _vm.$set(_vm.profile, "title", $$v)
      },
      expression: "profile.title"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Current company")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "placeholder": "Current company*",
      "name": "affiliation",
      "required": ""
    },
    model: {
      value: (_vm.profile.affiliation),
      callback: function($$v) {
        _vm.$set(_vm.profile, "affiliation", $$v)
      },
      expression: "profile.affiliation"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("How do you classify yourself (e.g. organic chemist)")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "placeholder": "How do you classify yourself (e.g. organic chemist)*",
      "name": "classify",
      "required": ""
    },
    model: {
      value: (_vm.profile.classify),
      callback: function($$v) {
        _vm.$set(_vm.profile, "classify", $$v)
      },
      expression: "profile.classify"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Years of experience")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "number",
      "placeholder": "Years of experience*",
      "name": "experience",
      "required": ""
    },
    model: {
      value: (_vm.profile.experience),
      callback: function($$v) {
        _vm.$set(_vm.profile, "experience", $$v)
      },
      expression: "profile.experience"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Where did you do your undergraduate degree?")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "placeholder": "Where did you do your undergraduate degree?*",
      "name": "affiliation",
      "required": ""
    },
    model: {
      value: (_vm.profile.undergraduate),
      callback: function($$v) {
        _vm.$set(_vm.profile, "undergraduate", $$v)
      },
      expression: "profile.undergraduate"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Where did you do your graduate degree?")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "placeholder": "Where did you do your graduate degree?*",
      "name": "affiliation",
      "required": ""
    },
    model: {
      value: (_vm.profile.graduate),
      callback: function($$v) {
        _vm.$set(_vm.profile, "graduate", $$v)
      },
      expression: "profile.graduate"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Companies you worked for")]), _vm._v(" "), _c('md-textarea', {
    attrs: {
      "maxlength": "250",
      "required": ""
    },
    model: {
      value: (_vm.profile.companies),
      callback: function($$v) {
        _vm.$set(_vm.profile, "companies", $$v)
      },
      expression: "profile.companies"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Favorite target class")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "placeholder": "Favorite target class*",
      "name": "affiliation",
      "required": ""
    },
    model: {
      value: (_vm.profile.target_class),
      callback: function($$v) {
        _vm.$set(_vm.profile, "target_class", $$v)
      },
      expression: "profile.target_class"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "placeholder": "Email*",
      "name": "email",
      "type": "email",
      "required": ""
    },
    model: {
      value: (_vm.profile.email),
      callback: function($$v) {
        _vm.$set(_vm.profile, "email", $$v)
      },
      expression: "profile.email"
    }
  })], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Update Profile ")])], 1)])], 1), _vm._v(" "), _c('experiment-choice'), _vm._v(" "), _c('experiment-passed')], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 335:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-layout', {
    staticClass: "main_layout",
    attrs: {
      "md-gutter": "",
      "md-align": "center"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-column": "",
      "md-gutter": "",
      "md-align": "center"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "77px",
      "width": "265px",
      "margin": "50px 0 0 0"
    },
    attrs: {
      "src": __webpack_require__(52)
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "md-display-2",
    staticStyle: {
      "margin": "100px 0"
    }
  }, [_vm._v("RESULTS OF YOUR TEST")]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-align": "center"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('md-layout', {
    staticStyle: {
      "max-height": "110px"
    },
    attrs: {
      "md-align": "center"
    }
  }, [_c('h2', {
    staticStyle: {
      "color": "#6faa43 !important"
    }
  }, [_vm._v("HUMAN MOLECULES")])]), _vm._v(" "), _c('md-layout', [_c('ul', _vm._l((_vm.filterHuman), function(human) {
    return _c('li', {
      key: human.id,
      staticClass: "results-list-item"
    }, [_c('md-card', [_c('md-card-media-cover', [_c('md-card-media', [_c('img', {
      class: {
        liked: _vm.moleculeLiked(human)
      },
      staticStyle: {
        "width": "100%",
        "height": "auto"
      },
      attrs: {
        "src": '/static/mol/' + human.name + '.png'
      }
    })]), _vm._v(" "), _c('center', [(_vm.emotive()) ? _c('div', {
      staticClass: "emotions"
    }, [_c('span', {
      staticClass: "md-title"
    }, [_vm._v("Interest: "), _c('strong', [_vm._v(" " + _vm._s(_vm.moleculeInterestValue(human)) + " % ")])]), _vm._v(" "), _c('span', {
      staticClass: "md-title"
    }, [_vm._v("Excitement: "), _c('strong', [_vm._v(" " + _vm._s(_vm.moleculeExcitementValue(human)) + " % ")])]), _vm._v(" "), _c('span', {
      staticClass: "md-title"
    }, [_vm._v("Stress: "), _c('strong', [_vm._v(_vm._s(_vm.moleculeStressValue(human)) + " % ")])])]) : _vm._e()])], 1)], 1)], 1)
  }), 0)])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('md-layout', {
    staticStyle: {
      "max-height": "110px"
    },
    attrs: {
      "md-align": "center"
    }
  }, [_c('h2', {
    staticStyle: {
      "color": "#58b1df !important"
    }
  }, [_vm._v("GAN MOLECULES")])]), _vm._v(" "), _c('md-layout', [_c('ul', _vm._l((_vm.filterGAN), function(gan) {
    return _c('li', {
      key: gan.id,
      staticClass: "results-list-item"
    }, [_c('md-card', [_c('md-card-media-cover', [_c('md-card-media', [_c('img', {
      class: {
        liked: _vm.moleculeLiked(gan)
      },
      staticStyle: {
        "width": "100%",
        "height": "auto"
      },
      attrs: {
        "src": '/static/mol/' + gan.name + '.png'
      }
    })]), _vm._v(" "), _c('center', [(_vm.emotive()) ? _c('div', {
      staticClass: "emotions"
    }, [_c('span', {
      staticClass: "md-title"
    }, [_vm._v("Interest: "), _c('strong', [_vm._v(" " + _vm._s(_vm.moleculeInterestValue(gan)) + " % ")])]), _vm._v(" "), _c('span', {
      staticClass: "md-title"
    }, [_vm._v("Excitement: "), _c('strong', [_vm._v(" " + _vm._s(_vm.moleculeExcitementValue(gan)) + " % ")])]), _vm._v(" "), _c('span', {
      staticClass: "md-title"
    }, [_vm._v("Stress: "), _c('strong', [_vm._v(" " + _vm._s(_vm.moleculeStressValue(gan)) + " % ")])])]) : _vm._e()])], 1)], 1)], 1)
  }), 0)])], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 336:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-layout', {
    attrs: {
      "md-column": "",
      "md-gutter": ""
    }
  }, [_c('md-toolbar', {
    staticClass: "md-transparent"
  }, [_c('img', {
    staticClass: "top_logo",
    attrs: {
      "src": __webpack_require__(201)
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "md-title",
    staticStyle: {
      "flex": "1"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('ul', {
    staticClass: "top_menu"
  }, [_c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#about'),
      expression: "'#about'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("About")])]), _vm._v(" "), _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#contacts'),
      expression: "'#contacts'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Contacts")])]), _vm._v(" "), _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#login'),
      expression: "'#login'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Login")])])])]), _vm._v(" "), _c('md-layout', {
    staticClass: "main_img"
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "how_it_works",
    attrs: {
      "md-align": "center"
    }
  }, [_c('h2', [_vm._v("How it works")])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-align": "center",
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "how_box",
    attrs: {
      "md-flex": "15",
      "md-align": "center",
      "md-column": ""
    }
  }, [_c('div', {
    staticClass: "how_box_icon icon1"
  }), _vm._v(" "), _c('div', {
    staticClass: "how_box_header"
  }, [_vm._v("REGISTER")]), _vm._v(" "), _c('div', {
    staticClass: "how_box_text"
  }, [_vm._v("Enter some information about your experience in medicinal chemistry for further analysis")])]), _vm._v(" "), _c('md-layout', {
    staticClass: "how_box",
    attrs: {
      "md-flex": "15",
      "md-align": "center",
      "md-column": ""
    }
  }, [_c('div', {
    staticClass: "how_box_icon icon2"
  }), _vm._v(" "), _c('div', {
    staticClass: "how_box_header"
  }, [_vm._v("SELECT TEST")]), _vm._v(" "), _c('div', {
    staticClass: "how_box_text"
  }, [_vm._v("Select a type of the experiment to run:"), _c('br'), _vm._v("\n                                    - using EMOTIV device"), _c('br'), _vm._v("\n                                    - or without it")])]), _vm._v(" "), _c('md-layout', {
    staticClass: "how_box",
    attrs: {
      "md-flex": "15",
      "md-align": "center",
      "md-column": ""
    }
  }, [_c('div', {
    staticClass: "how_box_icon icon3"
  }), _vm._v(" "), _c('div', {
    staticClass: "how_box_header"
  }, [_vm._v("TAKE THE TEST")]), _vm._v(" "), _c('div', {
    staticClass: "how_box_text"
  }, [_vm._v("Look at the molecules and Like/Dislike or Look at the molecules and guess if the molecule is designed by the GAN or another medicinal chemistct")])]), _vm._v(" "), _c('md-layout', {
    staticClass: "how_box",
    attrs: {
      "md-flex": "15",
      "md-align": "center",
      "md-column": ""
    }
  }, [_c('div', {
    staticClass: "how_box_icon icon4"
  }), _vm._v(" "), _c('div', {
    staticClass: "how_box_header"
  }, [_vm._v("GET A REPORT")]), _vm._v(" "), _c('div', {
    staticClass: "how_box_text"
  }, [_vm._v("We are working on immediate reporting You will get a comprehensive report after several medicinal chemists join the experiment")])])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "l_what_is",
    attrs: {
      "md-align": "center",
      "id": "about"
    }
  }, [_c('md-layout', {
    staticClass: "what_is_container",
    attrs: {
      "md-flex": "45",
      "md-column": ""
    }
  }, [_c('md-toolbar', {
    staticClass: "md-transparent",
    staticStyle: {
      "padding": "30px"
    }
  }, [_c('h2', {
    staticClass: "md-title",
    staticStyle: {
      "flex": "1"
    }
  }, [_vm._v("WHAT IS CHEMISTRY.AI ")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-fab md-mini open-button",
    on: {
      "click": function($event) {
        _vm.show_what_is = !_vm.show_what_is
      }
    }
  }, [(_vm.show_what_is) ? _c('md-icon', [_vm._v("close")]) : _c('md-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('md-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_what_is),
      expression: "show_what_is"
    }],
    staticClass: "l_about"
  }, [_c('p', [_vm._v("\n     \t\tMedicinal chemistry is among one of the most important and intellectually-challenging professions on the planet. It takes decades of training and experience to learn the properties of the thousands of molecules and their effects on the biological systems, model organisms and diseases. Decisions made by the medicinal chemists affect the lives of billions of people and may result in the billions of dollars of gains or losses by the pharmaceutical companies. \n          ")]), _c('p', [_vm._v("\n          Experienced medicinal chemists have the ability to accurately describe the properties and the possible effects of the molecule just by looking at its structure as well as at the various numerical parameters. \n\t\t")]), _c('p', [_vm._v("\n\t\tMedicinal chemists may like or dislike certain molecular structures because of their experience with the hundreds or thousands of molecules they encountered previously and the emotional response to the molecule is usually biased and related to the molecules and the classes of molecules they are most familiar with. \n\t\t")]), _c('p', [_vm._v("\n\t\tChemistry.AI will provide a platform for the medicinal chemists to look at the various classes of molecules and measure their brain activity and other physiological parameters during the exposure to the molecule. \n\t\t")]), _c('p', [_vm._v("\n\t\tThe system is intended to answer the following questions: \n \t\t")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v(" Can a medicinal chemist have a ”hunch” about the good or bad molecule?")]), _vm._v(" "), _c('li', [_vm._v("Can a medicinal chemist predict the outcome of a clinical trial by just looking at the molecule? ")]), _vm._v(" "), _c('li', [_vm._v(" Can we create a test to compare medicinal chemists using 1 & 2 questions?")]), _vm._v(" "), _c('li', [_vm._v(" Can the medicinal chemist distinguish the molecules created by the human medicinal chemists from those generated by artificial intelligence (A.I.)")]), _vm._v(" "), _c('li', [_vm._v(" Can we use the top-performing medicinal chemists as discriminators for training the deep neural networks?")]), _vm._v(" "), _c('li', [_vm._v(" Can we pinpoint the are a of the brain responsible for recognizing the good molecules?")])]), _vm._v(" "), _c('p')])], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-align": "center",
      "id": "login"
    }
  }, [_c('md-layout', {
    staticClass: "user_form_container",
    attrs: {
      "md-flex": "70"
    }
  }, [_c('user-form', {
    staticClass: "userf"
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "footer",
    attrs: {
      "id": "contacts"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20",
      "md-flex-offset": "20"
    }
  }, [_c('strong', [_vm._v("Insilico Medicine, Inc.")]), _vm._v(" \n      Emerging Technology Centers "), _c('br'), _vm._v("\n      Johns Hopkins University Eastern Campus "), _c('br'), _vm._v("\n      Suite B301, 1101 East 33rd St."), _c('br'), _vm._v("\n      Baltimore, MD 21218"), _c('br'), _c('br'), _vm._v("\n\n     Phone: +1 443 451 7212"), _c('br'), _vm._v("\n     Fax: +1 443 451 7210"), _c('br'), _c('br'), _vm._v("\n\n     Email: zhu(at)insilicomedicine.com"), _c('br')])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 337:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('experiment', {
    staticClass: "exp",
    attrs: {
      "experiment_type": _vm.experiment_type
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 338:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-layout', {
    staticClass: "userform",
    attrs: {
      "md-align": "center"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.isAuth) ? _c('experiment-choice') : _c('md-card', {
    staticClass: "user-form-card",
    attrs: {
      "md-with-hover": ""
    }
  }, [_c('md-card-content', [_c('md-tabs', [_c('md-tab', {
    attrs: {
      "id": "signin-tab",
      "md-label": "Sign In"
    }
  }, [_c('form', {
    staticClass: "user-form",
    attrs: {
      "id": "login_form"
    },
    on: {
      "submit": _vm.performLogin
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("Login")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "placeholder": "Login",
      "name": "login",
      "required": ""
    },
    model: {
      value: (_vm.login),
      callback: function($$v) {
        _vm.login = $$v
      },
      expression: "login"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Password")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "placeholder": "Password",
      "name": "password",
      "type": "password",
      "required": ""
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Sign In")])], 1)]), _vm._v(" "), _c('md-tab', {
    attrs: {
      "id": "register-tab",
      "md-label": "Register"
    }
  }, [_c('form', {
    staticClass: "user-form",
    attrs: {
      "id": "register_form"
    },
    on: {
      "submit": _vm.performRegister
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("Username")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "placeholder": "Username",
      "name": "username",
      "required": ""
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "placeholder": "Email",
      "name": "email",
      "type": "email",
      "required": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Password")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "placeholder": "Password",
      "name": "password1",
      "type": "password",
      "required": ""
    },
    model: {
      value: (_vm.password1),
      callback: function($$v) {
        _vm.password1 = $$v
      },
      expression: "password1"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Repeat Password")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "placeholder": "Repeat Password",
      "name": "password2",
      "type": "password",
      "required": ""
    },
    model: {
      value: (_vm.password2),
      callback: function($$v) {
        _vm.password2 = $$v
      },
      expression: "password2"
    }
  })], 1), _vm._v(" "), _c('md-checkbox', {
    attrs: {
      "id": "terms-checkbox",
      "name": "terms",
      "required": ""
    }
  }), _vm._v(" I agree to "), _c('a', {
    attrs: {
      "href": "/static/Terms_and_conditions.pdf",
      "target": "_blank"
    }
  }, [_vm._v("Terms and Conditions")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Create Account")])], 1)])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 339:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('md-snackbar', {
    ref: "snackbar",
    attrs: {
      "md-position": "top center",
      "md-duration": "4000"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), _c('md-button', {
    staticClass: "md-accent",
    on: {
      "click": function($event) {
        return _vm.$refs.snackbar.close()
      }
    }
  }, [_vm._v("Close")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 340:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-boards', {
    attrs: {
      "md-auto": true,
      "md-infinite": true,
      "md-duration": 10000,
      "md-swipeable": true
    }
  }, [_c('md-board', {
    attrs: {
      "id": "slide1"
    }
  }, [_c('img', {
    staticClass: "onboarding-image",
    attrs: {
      "src": __webpack_require__(326)
    }
  })]), _vm._v(" "), _c('md-board', {
    attrs: {
      "id": "slide2"
    }
  }, [_c('img', {
    staticClass: "onboarding-image",
    attrs: {
      "src": __webpack_require__(327)
    }
  })]), _vm._v(" "), _c('md-board', {
    attrs: {
      "id": "slide3"
    }
  }, [_c('img', {
    staticClass: "onboarding-image",
    attrs: {
      "src": __webpack_require__(328)
    }
  })])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isProfileFilled) ? _c('md-layout', {
    staticClass: "exp_choice",
    staticStyle: {
      "flex": "0 1 auto"
    },
    attrs: {
      "md-gutter": "",
      "md-column": "",
      "md-vertical-align": "start"
    }
  }, [_c('md-layout', {
    staticStyle: {
      "flex": "0 1 0%",
      "margin": "50px 0"
    }
  }, [_c('h2', {}, [_vm._v("CHOOSE THE TYPE OF EXPERIMENT")])]), _vm._v(" "), _c('md-layout', [_c('md-layout', {
    staticClass: "l_choice",
    attrs: {
      "md-align": "center"
    }
  }, [_c('img', {
    staticClass: "choice_icon",
    staticStyle: {
      "width": "245px",
      "height": "115px"
    },
    attrs: {
      "src": __webpack_require__(325)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "choice_text md-body-1"
  }, [_vm._v("\n     \n     In this experiment you'll have to put likes\\dislikes based on your perception of the molecule. \n     You can have multiple criterions but try just to give the overall impression of the molecule you see. "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n     You'll have 5 seconds on each molecule\n     \n     ")]), _vm._v(" "), _c('md-button', {
    staticClass: "choice_button like_button",
    on: {
      "click": _vm.gotoExperimentLike
    }
  }, [_vm._v("\n       LIKE OR DISIKE\n     ")])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "l_choice",
    attrs: {
      "md-align": "center"
    }
  }, [_c('img', {
    staticClass: "choice_icon",
    staticStyle: {
      "width": "245px",
      "height": "115px"
    },
    attrs: {
      "src": __webpack_require__(324)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "choice_text md-body-1"
  }, [_vm._v("\n     In this experiment you'll have to distinguish human and GAN designed molecules. \n     Make your decision wisely as it's not that easy to tell one from another. \n     Try to beat AI and guess as much as possible. "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" \n     You'll have 5 seconds on each molecule   \n     ")]), _vm._v(" "), _c('md-button', {
    staticClass: "choice_button hg_button",
    on: {
      "click": _vm.gotoExperimentGan
    }
  }, [_vm._v("\n       HUMAN OR GAN\n     ")])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "l_choice",
    attrs: {
      "md-align": "center"
    }
  }, [_c('img', {
    staticClass: "choice_icon",
    staticStyle: {
      "width": "95px",
      "height": "115px"
    },
    attrs: {
      "src": __webpack_require__(323)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "choice_text md-body-1"
  }, [_vm._v("\n     Use EMOTIV device to record emotions that each molecule evokes in you.\n     We'll record your EEG, facial expression and will track your glance."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n     You'll have 5 seconds on each molecule \n     ")]), _vm._v(" "), _c('md-button', {
    staticClass: "choice_button emotiv_button",
    on: {
      "click": _vm.gotoExperimentCortex
    }
  }, [_vm._v("\n       EMOTIVE EEG\n     ")])], 1)], 1)], 1) : _c('md-layout', {
    staticClass: "exp_choice",
    attrs: {
      "md-align": "center"
    }
  }, [_c('h2', [_vm._v("PLEASE FILL IN "), _c('router-link', {
    attrs: {
      "to": "profile"
    }
  }, [_vm._v("PROFILE")]), _vm._v(" FORM TO START THE EXPERIMENT")], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 342:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-layout', {
    attrs: {
      "md-column": "",
      "md-gutter": ""
    }
  }, [_c('md-toolbar', {
    staticClass: "md-transparent"
  }, [_c('img', {
    staticClass: "top_logo",
    attrs: {
      "src": __webpack_require__(201)
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "md-title",
    staticStyle: {
      "flex": "1"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('ul', {
    staticClass: "top_menu"
  }, [_c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#about'),
      expression: "'#about'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("About")])]), _vm._v(" "), _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#contacts'),
      expression: "'#contacts'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Contacts")])]), _vm._v(" "), (_vm.isAuth) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "profile"
    }
  }, [_vm._v("Profile")])], 1) : _vm._e(), _vm._v(" "), (_vm.isAuth) ? _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.performLogout
    }
  }, [_vm._v("Logout")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#login'),
      expression: "'#login'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Login")])])])]), _vm._v(" "), _c('md-layout', {
    staticClass: "main_img"
  }), _vm._v(" "), _c('md-layout', {
    staticStyle: {
      "margin-top": "50px"
    },
    attrs: {
      "md-align": "center",
      "id": "login"
    }
  }, [_c('md-layout', {
    staticClass: "user_form_container",
    attrs: {
      "md-flex": "70"
    }
  }, [_c('user-form', {
    staticClass: "userf"
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "how_it_works",
    attrs: {
      "md-align": "center"
    }
  }, [_c('h2', [_vm._v("HOW IT WORKS")])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-align": "center",
      "md-vertical-align": "top",
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "how_box",
    attrs: {
      "md-flex": "15",
      "md-align": "center",
      "md-column": ""
    }
  }, [_c('div', {
    staticClass: "how_box_icon icon1"
  }), _vm._v(" "), _c('div', {
    staticClass: "how_box_header"
  }, [_vm._v("REGISTER")]), _vm._v(" "), _c('div', {
    staticClass: "how_box_text"
  }, [_vm._v("Enter some information about your experience in medicinal chemistry for further analysis\n\t       "), _c('br'), _vm._v("  "), _c('br'), _vm._v(" \n\t        ")])]), _vm._v(" "), _c('md-layout', {
    staticClass: "how_box",
    attrs: {
      "md-flex": "15",
      "md-align": "center",
      "md-column": ""
    }
  }, [_c('div', {
    staticClass: "how_box_icon icon2"
  }), _vm._v(" "), _c('div', {
    staticClass: "how_box_header"
  }, [_vm._v("SELECT TEST")]), _vm._v(" "), _c('div', {
    staticClass: "how_box_text"
  }, [_vm._v("Select a type of the experiment to run:"), _c('br'), _vm._v("\n                                    - using EMOTIV device"), _c('br'), _vm._v("\n                                    - or without it\n                                     "), _c('br'), _vm._v("  "), _c('br'), _vm._v(" ")])]), _vm._v(" "), _c('md-layout', {
    staticClass: "how_box",
    attrs: {
      "md-flex": "15",
      "md-align": "center",
      "md-column": ""
    }
  }, [_c('div', {
    staticClass: "how_box_icon icon3"
  }), _vm._v(" "), _c('div', {
    staticClass: "how_box_header"
  }, [_vm._v("TAKE THE TEST")]), _vm._v(" "), _c('div', {
    staticClass: "how_box_text"
  }, [_vm._v("Look at the molecules and Like/Dislike or Look at the molecules and guess \n\t      if the molecule is designed by the GAN or another medicinal chemistct\n\t     ")])]), _vm._v(" "), _c('md-layout', {
    staticClass: "how_box",
    attrs: {
      "md-flex": "15",
      "md-align": "center",
      "md-column": ""
    }
  }, [_c('div', {
    staticClass: "how_box_icon icon4"
  }), _vm._v(" "), _c('div', {
    staticClass: "how_box_header"
  }, [_vm._v("GET A REPORT")]), _vm._v(" "), _c('div', {
    staticClass: "how_box_text"
  }, [_vm._v("We are working on immediate reporting You will get a comprehensive report after several medicinal chemists join the experiment")])])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "l_what_is",
    attrs: {
      "md-align": "center",
      "md-vertical-align": "center",
      "id": "about"
    }
  }, [_c('md-layout', {
    staticClass: "what_is_container",
    attrs: {
      "md-flex": "45",
      "md-column": ""
    }
  }, [_c('md-toolbar', {
    staticClass: "md-transparent",
    staticStyle: {
      "padding": "30px"
    }
  }, [_c('h2', {
    staticClass: "md-title",
    staticStyle: {
      "flex": "1"
    }
  }, [_vm._v("WHAT IS CHEMISTRY.AI ")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-fab md-mini open-button",
    on: {
      "click": function($event) {
        _vm.show_what_is = !_vm.show_what_is
      }
    }
  }, [(_vm.show_what_is) ? _c('md-icon', [_vm._v("close")]) : _c('md-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('md-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_what_is),
      expression: "show_what_is"
    }],
    staticClass: "l_about"
  }, [_c('p', [_vm._v("\n     \t\tMedicinal chemistry is among one of the most important and intellectually-challenging professions on the planet. It takes decades of training and experience to learn the properties of the thousands of molecules and their effects on the biological systems, model organisms and diseases. Decisions made by the medicinal chemists affect the lives of billions of people and may result in the billions of dollars of gains or losses by the pharmaceutical companies. \n          ")]), _c('p', [_vm._v("\n          Experienced medicinal chemists have the ability to accurately describe the properties and the possible effects of the molecule just by looking at its structure as well as at the various numerical parameters. \n\t\t")]), _c('p', [_vm._v("\n\t\tMedicinal chemists may like or dislike certain molecular structures because of their experience with the hundreds or thousands of molecules they encountered previously and the emotional response to the molecule is usually biased and related to the molecules and the classes of molecules they are most familiar with. \n\t\t")]), _c('p', [_vm._v("\n\t\tChemistry.AI will provide a platform for the medicinal chemists to look at the various classes of molecules and measure their brain activity and other physiological parameters during the exposure to the molecule. \n\t\t")]), _c('p', [_vm._v("\n\t\tThe system is intended to answer the following questions: \n \t\t")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v(" Can a medicinal chemist have a ”hunch” about the good or bad molecule?")]), _vm._v(" "), _c('li', [_vm._v("Can a medicinal chemist predict the outcome of a clinical trial by just looking at the molecule? ")]), _vm._v(" "), _c('li', [_vm._v(" Can we create a test to compare medicinal chemists using 1 & 2 questions?")]), _vm._v(" "), _c('li', [_vm._v(" Can the medicinal chemist distinguish the molecules created by the human medicinal chemists from those generated by artificial intelligence (A.I.)")]), _vm._v(" "), _c('li', [_vm._v(" Can we use the top-performing medicinal chemists as discriminators for training the deep neural networks?")]), _vm._v(" "), _c('li', [_vm._v(" Can we pinpoint the are a of the brain responsible for recognizing the good molecules?")])]), _vm._v(" "), _c('p')])], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticStyle: {
      "min-height": "500px",
      "margin": "100px 0 150px 0"
    },
    attrs: {
      "md-align": "center"
    }
  }, [_c('iframe', {
    attrs: {
      "width": "60%",
      "height": "300",
      "src": "https://www.youtube.com/embed/0SyZQGfcuho"
    }
  })]), _vm._v(" "), _c('md-layout', {
    staticClass: "footer",
    attrs: {
      "id": "contacts"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('div', {
    staticClass: "google-map",
    attrs: {
      "id": "google_map"
    }
  })]), _vm._v(" "), _c('md-layout', {
    staticClass: "l_contacts",
    attrs: {
      "md-flex": "50",
      "md-column": ""
    }
  }, [_c('strong', [_vm._v("Insilico Medicine")]), _vm._v(" "), _c('p', [_vm._v("\n      Rm 8, Unit 111-113 "), _c('br'), _vm._v("\n      ICT Co-Working Centre "), _c('br'), _vm._v("\n      1/F Enterprise Place"), _c('br'), _vm._v("\n      5 Science Park West Avenue, Hong Kong"), _c('br'), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Email:")]), _vm._v(" zhu(at)insilicomedicine.com"), _c('br')])]), _vm._v(" "), _c('md-toolbar', {
    staticClass: "md-transparent footer-toobar"
  }, [_c('h2', {
    staticStyle: {
      "flex": "1"
    }
  }, [_vm._v("© 2017-" + _vm._s(_vm.current_year) + " All Right Reserved. Insilico Medicine, Inc.")]), _vm._v(" "), _c('ul', {
    staticClass: "bottom_menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/insilicomedicine",
      "target": "_blank"
    }
  }, [_c('svg', {
    staticClass: "t-sociallinks__svg",
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "30px",
      "height": "30px",
      "viewBox": "0 0 48 48",
      "enable-background": "new 0 0 48 48",
      "xml:space": "preserve"
    }
  }, [_c('desc', [_vm._v("Facebook")]), _c('path', {
    staticStyle: {
      "fill": "#000000"
    },
    attrs: {
      "d": "M47.761,24c0,13.121-10.638,23.76-23.758,23.76C10.877,47.76,0.239,37.121,0.239,24c0-13.124,10.638-23.76,23.764-23.76C37.123,0.24,47.761,10.876,47.761,24 M20.033,38.85H26.2V24.01h4.163l0.539-5.242H26.2v-3.083c0-1.156,0.769-1.427,1.308-1.427h3.318V9.168L26.258,9.15c-5.072,0-6.225,3.796-6.225,6.224v3.394H17.1v5.242h2.933V38.85z"
    }
  })])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://twitter.com/InSilicoMeds",
      "target": "_blank"
    }
  }, [_c('svg', {
    staticClass: "t-sociallinks__svg",
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "30px",
      "height": "30px",
      "viewBox": "0 0 48 48",
      "enable-background": "new 0 0 48 48",
      "xml:space": "preserve"
    }
  }, [_c('desc', [_vm._v("Twitter")]), _c('path', {
    staticStyle: {
      "fill": "#000000"
    },
    attrs: {
      "d": "M47.762,24c0,13.121-10.639,23.76-23.761,23.76S0.24,37.121,0.24,24c0-13.124,10.639-23.76,23.761-23.76 S47.762,10.876,47.762,24 M38.031,12.375c-1.177,0.7-2.481,1.208-3.87,1.481c-1.11-1.186-2.694-1.926-4.455-1.926 c-3.364,0-6.093,2.729-6.093,6.095c0,0.478,0.054,0.941,0.156,1.388c-5.063-0.255-9.554-2.68-12.559-6.367 c-0.524,0.898-0.825,1.947-0.825,3.064c0,2.113,1.076,3.978,2.711,5.07c-0.998-0.031-1.939-0.306-2.761-0.762v0.077 c0,2.951,2.1,5.414,4.889,5.975c-0.512,0.14-1.05,0.215-1.606,0.215c-0.393,0-0.775-0.039-1.146-0.109 c0.777,2.42,3.026,4.182,5.692,4.232c-2.086,1.634-4.712,2.607-7.567,2.607c-0.492,0-0.977-0.027-1.453-0.084 c2.696,1.729,5.899,2.736,9.34,2.736c11.209,0,17.337-9.283,17.337-17.337c0-0.263-0.004-0.527-0.017-0.789 c1.19-0.858,2.224-1.932,3.039-3.152c-1.091,0.485-2.266,0.811-3.498,0.958C36.609,14.994,37.576,13.8,38.031,12.375"
    }
  })])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/channel/UCMUen0Syr66mft-SlDgmv1g/videos",
      "target": "_blank"
    }
  }, [_c('svg', {
    staticClass: "t-sociallinks__svg",
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "30px",
      "height": "30px",
      "viewBox": "-455 257 48 48",
      "enable-background": "new -455 257 48 48",
      "xml:space": "preserve"
    }
  }, [_c('desc', [_vm._v("Youtube")]), _c('path', {
    staticStyle: {
      "fill": "#000000"
    },
    attrs: {
      "d": "M-431,257.013c13.248,0,23.987,10.74,23.987,23.987s-10.74,23.987-23.987,23.987s-23.987-10.74-23.987-23.987S-444.248,257.013-431,257.013z M-419.185,275.093c-0.25-1.337-1.363-2.335-2.642-2.458c-3.054-0.196-6.119-0.355-9.178-0.357c-3.059-0.002-6.113,0.154-9.167,0.347c-1.284,0.124-2.397,1.117-2.646,2.459c-0.284,1.933-0.426,3.885-0.426,5.836s0.142,3.903,0.426,5.836c0.249,1.342,1.362,2.454,2.646,2.577c3.055,0.193,6.107,0.39,9.167,0.39c3.058,0,6.126-0.172,9.178-0.37c1.279-0.124,2.392-1.269,2.642-2.606c0.286-1.93,0.429-3.879,0.429-5.828C-418.756,278.971-418.899,277.023-419.185,275.093zM-433.776,284.435v-7.115l6.627,3.558L-433.776,284.435z"
    }
  })])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.linkedin.com/company/in-silico-medicine-inc",
      "target": "_blank"
    }
  }, [_c('svg', {
    staticClass: "t-sociallinks__svg",
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "30px",
      "height": "30px",
      "viewBox": "-615 1477 48 48",
      "enable-background": "new -615 1477 48 48",
      "xml:space": "preserve"
    }
  }, [_c('desc', [_vm._v("LinkedIn")]), _c('path', {
    staticStyle: {
      "fill": "#000000"
    },
    attrs: {
      "d": "M-566.999,1501c0,13.256-10.746,24-24,24c-13.256,0-24.002-10.744-24.002-24c0-13.254,10.746-24,24.002-24C-577.745,1477-566.999,1487.746-566.999,1501z M-605.506,1514.975h6.22v-20.004h-6.22V1514.975z M-602.396,1492.236c1.987,0,3.602-1.615,3.602-3.606c0-1.99-1.615-3.605-3.602-3.605c-1.993,0-3.604,1.615-3.604,3.605C-606,1490.621-604.389,1492.236-602.396,1492.236z M-576,1504.002c0-5.387-1.163-9.529-7.454-9.529c-3.023,0-5.054,1.658-5.884,3.231h-0.085v-2.733h-5.964v20.004h6.216v-9.896c0-2.609,0.493-5.137,3.729-5.137c3.186,0,3.232,2.984,3.232,5.305v9.729H-576V1504.002z"
    }
  })])])])])])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 343:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-layout', {
    staticClass: "exp-layout"
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "l_experiment",
    attrs: {
      "md-column": "",
      "md-align": "center"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "7%",
      "position": "absolute",
      "top": "2%"
    },
    attrs: {
      "src": __webpack_require__(52)
    }
  })]), _vm._v(" "), (_vm.experiment_type === 2 && _vm.emotive_device == '') ? _c('span', {
    staticClass: "emo_state_device"
  }, [_c('md-progress', {
    attrs: {
      "md-indeterminate": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.experiment_type === 2 && !_vm.loaded) ? _c('div', [_c('center', [_c('span', {
    staticClass: "md-display-1 fade-in"
  }, [_vm._v("\n        Please connect Emotiv Epoc+ to start the Experiment.\n      ")])])], 1) : (!_vm.loaded) ? _c('div', [_c('center', [_c('span', {
    staticClass: "md-display-1 fade-in"
  }, [_vm._v("\n        loading ...\n       ")])])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.mols), function(molecule, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.loaded && index === _vm.moleculeIndex),
        expression: "loaded && index === moleculeIndex"
      }],
      key: index,
      staticStyle: {
        "height": "100%"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === _vm.moleculeIndex),
        expression: "index === moleculeIndex"
      }],
      staticStyle: {
        "height": "100%"
      }
    }, [_c('img', {
      staticClass: "fade-in-fast",
      staticStyle: {
        "height": "90%",
        "border-radius": "25px",
        "flex": "1"
      },
      attrs: {
        "src": '/static/mol/' + molecule.name + '.png'
      }
    }), _vm._v(" "), _c('div', [(_vm.show_emo_state && _vm.experiment_type === 2) ? _c('div', {
      staticClass: "emo_state"
    }, [(_vm.emotive_device == '') ? _c('p', [_c('md-spinner', {
      staticClass: "md-accent",
      attrs: {
        "md-size": 20,
        "md-indeterminate": ""
      }
    }), _vm._v(" waitng for device ...\n        ")], 1) : _c('p', [_vm._v("\n          " + _vm._s(_vm.emotive_device) + "\n          "), _c('md-progress', {
      attrs: {
        "md-progress": _vm.met.interest
      }
    }), _vm._v(" "), _c('md-progress', {
      attrs: {
        "md-progress": _vm.met.stress
      }
    }), _vm._v(" "), _c('md-progress', {
      attrs: {
        "md-progress": _vm.met.relaxation
      }
    }), _vm._v(" "), _c('md-progress', {
      attrs: {
        "md-progress": _vm.met.excitement
      }
    }), _vm._v(" "), _c('md-progress', {
      attrs: {
        "md-progress": _vm.met.engagement
      }
    }), _vm._v(" "), _c('md-progress', {
      attrs: {
        "md-progress": _vm.met.long_term_excitement
      }
    }), _vm._v(" "), _c('md-progress', {
      attrs: {
        "md-progress": _vm.met.focus
      }
    })], 1)]) : _vm._e(), _vm._v(" "), _c('center', [(_vm.experiment_type != 2) ? _c('md-button', {
      staticClass: "md-raised md-primary like_button",
      on: {
        "click": function($event) {
          return _vm.rate(molecule.id, molecule.design, _vm.moleculeIndex, 0)
        }
      }
    }, [(_vm.experiment_type == 0) ? _c('span', [_vm._v("Like")]) : _c('span', [_vm._v("Human")])]) : _vm._e(), _vm._v(" "), (_vm.experiment_type != 2) ? _c('md-button', {
      staticClass: "md-raised md-warn dislike_button",
      on: {
        "click": function($event) {
          return _vm.rate(molecule.id, molecule.design, _vm.moleculeIndex, 1)
        }
      }
    }, [(_vm.experiment_type == 0) ? _c('span', [_vm._v("Dislike")]) : _c('span', [_vm._v("GAN")])]) : _vm._e()], 1)], 1)])])
  }), _vm._v(" "), (false) ? _c('md-layout', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.moleculeIndex === _vm.mols.length),
      expression: "moleculeIndex === mols.length"
    }]
  }, [_c('h2', [_vm._v("Done!")]), _vm._v(" "), (_vm.experiment_type == 0) ? _c('p', [_vm._v("\n    results: Human Liked: " + _vm._s(_vm.humanLiked) + ". GAN Liked: " + _vm._s(_vm.ganLiked) + "\n    ")]) : _c('p', [_vm._v("\n    results: Right: " + _vm._s(_vm.guessedRight) + ". Wrong: " + _vm._s(_vm.guessedWrong) + "\n    ")])])]) : _vm._e()], 2), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 344:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-layout', {
    attrs: {
      "md-align": "center",
      "md-vertical-align": "start"
    }
  }, [_c('md-card', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "md-with-hover": ""
    }
  }, [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("Previous Experiments")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  })]), _vm._v(" "), _c('md-card-content', [_c('md-table', [_c('md-table-header', [_c('md-table-row', [_c('md-table-head', [_vm._v("#")]), _vm._v(" "), _c('md-table-head', [_vm._v("Datetime")]), _vm._v(" "), _c('md-table-head', [_vm._v("Experiment type")]), _vm._v(" "), _c('md-table-head'), _vm._v(" "), _c('md-table-head')], 1)], 1), _vm._v(" "), _c('md-table-body', _vm._l((_vm.experiments), function(exp, index) {
    return _c('md-table-row', {
      key: index
    }, [_c('md-table-cell', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('md-table-cell', [_vm._v(_vm._s(_vm._f("moment")(exp.started_at, "MMMM Do YYYY, HH:mm")))]), _vm._v(" "), _c('md-table-cell', [(exp.exp_type == 0) ? _c('span', [_vm._v("Like\\Dislike")]) : _vm._e(), _vm._v(" "), (exp.exp_type == 1) ? _c('span', [_vm._v("Human\\GAN")]) : _vm._e(), _vm._v(" "), (exp.exp_type == 2) ? _c('span', [_vm._v("EMOTIV")]) : _vm._e()]), _vm._v(" "), _c('md-table-cell', [_c('router-link', {
      staticClass: "md-raised md-primary",
      staticStyle: {
        "width": "60%"
      },
      attrs: {
        "tag": "a",
        "to": {
          name: 'experiment_result',
          params: {
            id: exp.id
          }
        }
      }
    }, [_vm._v("Details")])], 1), _vm._v(" "), _c('md-table-cell', [_c('md-button', {
      staticClass: "md-fab md-mini open-button",
      on: {
        "click": function($event) {
          return _vm.DeleteExperiment(exp.id)
        }
      }
    }, [_c('md-icon', [_vm._v("close")])], 1)], 1)], 1)
  }), 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 347:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/chemistryAI_logo.6c7ae99.png";

/***/ }),

/***/ 53:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_get__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_own_property_names__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_own_property_names___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_own_property_names__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_classCallCheck__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_createClass__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_inherits__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_events__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_events__);














var CORTEX_URL = 'wss://emotivcortex.com:54321';

var safeParse = function safeParse(msg) {
  try {
    return JSON.parse(msg);
  } catch (_) {
    return null;
  }
};
var makeChainablePromise = function makeChainablePromise(parent) {
  var ChainablePromise = function (_Promise) {
    __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_inherits___default()(ChainablePromise, _Promise);

    function ChainablePromise() {
      __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_classCallCheck___default()(this, ChainablePromise);

      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ChainablePromise.__proto__ || __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of___default()(ChainablePromise)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_createClass___default()(ChainablePromise, null, [{
      key: 'proxy',
      value: function proxy(method) {
        if (this.prototype[method]) return;

        if (parent[method]) console.log('method [ ' + method + ' ] is in PARENT');
        this.prototype[method] = function () {
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return this.then(function () {
            return parent[method].apply(parent, args);
          });
        };
      }
    }]);

    return ChainablePromise;
  }(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default.a);

  var proto = parent.constructor ? parent.constructor.prototype : {};

  console.log("The PROTO is: " + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(proto));

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_own_property_names___default()(proto)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var method = _step.value;

      if (typeof parent[method] === 'function' && method[0] !== '_' && method !== 'constructor') {
        ChainablePromise.proxy(method);
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return ChainablePromise;
};

var JSONRPCError = function (_Error) {
  __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_inherits___default()(JSONRPCError, _Error);

  function JSONRPCError(err) {
    __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_classCallCheck___default()(this, JSONRPCError);

    var _this2 = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_possibleConstructorReturn___default()(this, (JSONRPCError.__proto__ || __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of___default()(JSONRPCError)).call(this, err.message));

    _this2.name = _this2.constructor.name;
    _this2.message = err.message;
    _this2.code = err.code;
    return _this2;
  }

  __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_createClass___default()(JSONRPCError, [{
    key: 'toString',
    value: function toString() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_get___default()(JSONRPCError.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of___default()(JSONRPCError.prototype), 'toString', this).call(this) + (' (' + this.code + ')');
    }
  }]);

  return JSONRPCError;
}(Error);

var Cortex = function (_EventEmitter) {
  __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_inherits___default()(Cortex, _EventEmitter);

  function Cortex() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_classCallCheck___default()(this, Cortex);

    var _this3 = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Cortex.__proto__ || __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_prototype_of___default()(Cortex)).call(this));

    _this3.options = options;
    _this3.ws = new WebSocket(CORTEX_URL);
    _this3.msgId = 0;
    _this3.requests = {};
    _this3.streams = {};
    _this3.ws.addEventListener('message', _this3._onmsg.bind(_this3));
    _this3.ws.addEventListener('close', function () {
      _this3._log('ws: Socket closed');
      _this3.call = function () {
        return _this3.APIResult.reject(new Error('socket closed'));
      };
    });
    _this3.verbose = options.verbose !== null ? options.verbose : 1;
    _this3.APIResult = makeChainablePromise(_this3);
    _this3.ready = new _this3.APIResult(function (resolve) {
      return _this3.ws.addEventListener('open', resolve);
    }).then(function () {
      return _this3._log('ws: Socket opened');
    }).then(function () {
      return _this3.call('inspectApi');
    }).then(function (methods) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(methods), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var m = _step2.value;
          _this3.defineMethod(m.methodName, m.params);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      _this3._log('rpc: Added ' + methods.length + ' methods from inspectApi');
    }).catch(function (error) {
      return console.log('ERROR: ' + error);
    });
    return _this3;
  }

  __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_createClass___default()(Cortex, [{
    key: '_onmsg',
    value: function _onmsg(msg) {
      var data = safeParse(msg.data);
      if (!data) return this._warn('unparseable message', msg);

      this._debug('ws: <-', msg.data);

      if ('id' in data) {
        var id = data.id;
        this._log('[' + id + '] <-', data.result ? 'success' : 'error (' + data.error.message + ')');
        if (this.requests[id]) {
          this.requests[id](data.error, data.result);
        } else {
          this._warn('rpc: Got response for unknown id', id);
        }
      } else if ('sid' in data) {
        var dataKeys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data).filter(function (k) {
          return k !== 'sid' && k !== 'time' && Array.isArray(data[k]);
        });
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(dataKeys), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var k = _step3.value;

            this.emit(k, data) || this._warn('no listeners for stream event', k);
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      } else {
        this._log('rpc: Unrecognised data', data);
      }
    }
  }, {
    key: '_warn',
    value: function _warn() {
      var _console;

      for (var _len2 = arguments.length, msg = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        msg[_key2] = arguments[_key2];
      }

      if (this.verbose > 0) (_console = console).warn.apply(_console, ['[Cortex WARN]'].concat(msg));
    }
  }, {
    key: '_log',
    value: function _log() {
      var _console2;

      for (var _len3 = arguments.length, msg = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        msg[_key3] = arguments[_key3];
      }

      if (this.verbose > 1) (_console2 = console).warn.apply(_console2, ['[Cortex LOG]'].concat(msg));
    }
  }, {
    key: '_debug',
    value: function _debug() {
      var _console3;

      for (var _len4 = arguments.length, msg = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        msg[_key4] = arguments[_key4];
      }

      if (this.verbose > 2) (_console3 = console).warn.apply(_console3, ['[Cortex DEBUG]'].concat(msg));
    }
  }, {
    key: 'init',
    value: function init() {
      var _this4 = this;

      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          username = _ref.username,
          password = _ref.password,
          client_id = _ref.client_id,
          client_secret = _ref.client_secret,
          debit = _ref.debit;

      var result = this.getUserLogin().then(function (users) {
        if (users[0] && users[0] !== username) {
          _this4._log('init: Logging out other user', users[0]);
          return _this4.logout({ username: users[0] }).then(function () {
            return [];
          });
        }
        if (username) {
          _this4._log('init: Reusing existing login');
        } else {
          _this4._log('init: Logging in anonymously');
        }
        return users;
      }).then(function (users) {
        if (!users[0] && username && password) {
          _this4._log('init: Logging in as', username);
          return _this4.login({ username: username, password: password, client_id: client_id, client_secret: client_secret });
        }
      }).then(this.authorize({ client_id: client_id, client_secret: client_secret, debit: debit }).then(function (_ref2) {
        var _auth = _ref2._auth;

        _this4._log('init: Got auth token');
        _this4._debug('init: Auth token', _auth);
        _this4._auth = _auth;
      }));

      return result;
    }
  }, {
    key: 'close',
    value: function close() {
      var _this5 = this;

      return new this.APIResult(function (resolve) {
        _this5.ws.close();
        _this5.ws.once('close', resolve);
      });
    }
  }, {
    key: 'call',
    value: function call(method) {
      var _this6 = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var id = this.msgId++;
      var msg = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()({ jsonrpc: '2.0', method: method, params: params, id: id });
      this.ws.send(msg);
      this._log('[' + id + '] -> ' + method);

      this._debug('ws: ->', msg);
      return new this.APIResult(function (resolve, reject) {
        _this6.requests[id] = function (err, data) {
          delete _this6.requests[id];
          _this6._debug('rpc: err', err, 'data', data);
          if (err) return reject(new JSONRPCError(err));
          if (data) return resolve(data);
          return reject(new Error('Invalid JSON-RPC response'));
        };
      });
    }
  }, {
    key: 'defineMethod',
    value: function defineMethod(methodName) {
      var _this7 = this;

      var paramDefs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      if (this[methodName]) return;
      var needsAuth = paramDefs.some(function (p) {
        return p.name === '_auth';
      });
      var requiredParams = paramDefs.filter(function (p) {
        return p.required;
      }).map(function (p) {
        return p.name;
      });

      this[methodName] = function () {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        if (needsAuth && _this7._auth && !params._auth) {
          params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, params, { _auth: _this7._auth });
        }
        var missingParams = requiredParams.filter(function (p) {
          return params[p] == null;
        });
        if (missingParams.length > 0) {
          return _this7.APIResult.reject(new Error('Missing required params for ' + methodName + ': ' + missingParams.join(', ')));
        }
        return _this7.call(methodName, params);
      };

      this.APIResult.proxy(methodName);
    }
  }]);

  return Cortex;
}(__WEBPACK_IMPORTED_MODULE_12_events___default.a);

/* harmony default export */ __webpack_exports__["a"] = (Cortex);

Cortex.JSONRPCError = JSONRPCError;
Cortex.makeChainablePromise = makeChainablePromise;

/***/ }),

/***/ 54:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "router", function() { return router; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_material__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_material___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_material__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_material_dist_vue_material_css__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_material_dist_vue_material_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_material_dist_vue_material_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_router_sync__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_router__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_store_js__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_scrollto__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_scrollto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_MainPage__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_MainPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_MainPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ExperimentPage__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ExperimentPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_ExperimentPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_PreExperiment__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_PreExperiment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_PreExperiment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ExperimentResult__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ExperimentResult___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_ExperimentResult__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Profile__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Profile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Profile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_TestPage__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_TestPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_TestPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_ExperimentCortex__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_ExperimentCortex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_ExperimentCortex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__App__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__App__);






















__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_material___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_scrollto___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__webpack_require__(216));

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].material.registerTheme('default', {
	primary: 'light-green',
	accent: 'green',
	warn: 'red'
});

var router = new __WEBPACK_IMPORTED_MODULE_6_vue_router__["a" /* default */]({
	routes: [{ path: '/', name: 'home', component: __WEBPACK_IMPORTED_MODULE_9__components_MainPage___default.a }, { path: '/preexperiment', name: 'preexperiment', component: __WEBPACK_IMPORTED_MODULE_11__components_PreExperiment___default.a, props: true }, { path: '/experiment', name: 'experiment', component: __WEBPACK_IMPORTED_MODULE_10__components_ExperimentPage___default.a, props: true }, { path: '/result/:id', name: 'experiment_result', component: __WEBPACK_IMPORTED_MODULE_12__components_ExperimentResult___default.a, props: false }, { path: '/profile', component: __WEBPACK_IMPORTED_MODULE_13__components_Profile___default.a }, { path: '/test', component: __WEBPACK_IMPORTED_MODULE_14__components_TestPage___default.a, props: { message: 'Props message' } }, { path: '/cortex_api_test', component: __WEBPACK_IMPORTED_MODULE_15__components_ExperimentCortex___default.a }],
	scrollBehavior: function scrollBehavior(to, from, savedPosition) {
		return { x: 0, y: 0 };
	}
});

var unsync = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_7__store_store_js__["a" /* default */], router);

Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype, '$bus', {
	get: function get() {
		return this.$root.bus;
	}
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.errorHandler = function (err, vm, info) {
	console.log(err);
};

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].mixin({
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
		isAuth: 'isLoggedIn',
		currentUser: 'getUser'
	}))
});

new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
	el: '#app',
	template: '<App/>',
	router: router,
	store: __WEBPACK_IMPORTED_MODULE_7__store_store_js__["a" /* default */],
	components: { App: __WEBPACK_IMPORTED_MODULE_16__App___default.a },
	data: {
		bus: new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({}) }
});

/***/ })

},[54]);


// WEBPACK FOOTER //
// static/js/app.36dfc5f63e928be1047f.js